import { html, PropertyValueMap } from "lit";
import { customElement, property, state } from 'lit/decorators.js';
import { connect } from 'pwa-helpers';
import store from "../../store/store";
import { StoreState } from "../../store/store.interface";
import { BaseComponent } from "../../features/base-component/base-component";
import { booleanConverter } from "../../common/converters";
import { getCart, getCartStatus, getCartStoreCatalog, isHeCustomStoreCart } from "../cart/shop-cart/store/shop-cart.selectors";
import { ActionStatus } from "../../common/constants/action-status";
import { getContinueShoppingUrl } from "../../common/utils/cart-util";
import { ShopCart } from "../cart/shop-cart/interfaces/shop-cart.interface";
import { loading } from "../../common/constants/api-constants"
import emit from "../../common/events";
import { getShopCart } from "../cart/shop-cart/thunks/get-shop-cart.thunk";

/**
 * An element to redirect to the store page.
 */

 @customElement('mhecomm-continue-shopping')
 export class ContinueShopping extends connect(store)(BaseComponent) {

    /**
     *  Label Name
     */
    @property()
    labelname: string | undefined;

    /**
     * The store to checkout to. If not set the national checkout will be used.
     */
    @property()
    store?: string

    /**
     * Ignore empty cart
     */
    @property({converter: booleanConverter})
    ignoreEmptyCart?: boolean;

    /**
     * The button classes.
     */
    @property()
    btnClass = 'btn btn-lg btn-primary';

    /**
     * The button div classes.
     */
    @property()
    btnDivClass = 'd-grid';

    @property()
    redirectUrl?: string;

    @state()
    private continueShoppingUrl: string | undefined;

    @state()
    private isLoading = true;

    @state()
    private numberOfProducts;

    connectedCallback() {
      super.connectedCallback();
    }

    protected async firstUpdated(_changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>): Promise<void> {
      super.firstUpdated(_changedProperties);
      if (this.store) {
        await store.dispatch(getShopCart({ store: this.store }));
      }
    }
  
    renderComp() {
      return html `
       ${this.isLoading ? html`
        ${loading({ columns: 1, width: '100%', m: 'mt-0' })}
      ` : html `
        <div class="${this.btnDivClass} gap-2" style="${this.getDisplayClass()}">
          <button class=${this.btnClass} @click="${this._onClick}">${this.labelname}</button>
        </div>`}
      `;
    }

    async stateChanged(state: StoreState) {
      this.isLoading = getCartStatus(state) === ActionStatus.loading;
      if (!this.isLoading) {
        this.continueShoppingUrl = getContinueShoppingUrl(this.store, isHeCustomStoreCart(state), getCartStoreCatalog(state));
        this.numberOfProducts = this.getNumberOfProducts(getCart(state));
      }
    }

    _onClick() {
      if (this.continueShoppingUrl && !this.redirectUrl) {
        this.emitContinueShopping(this.continueShoppingUrl);
        window.location.href = this.continueShoppingUrl;
      }
      if (this.redirectUrl) {
        this.emitContinueShopping(this.redirectUrl);
        window.location.href = this.redirectUrl;
      }
    }

    getNumberOfProducts(cart?: ShopCart) {
      return cart ? cart?.products?.length : 0;
    }

    getDisplayClass() {
      return !this.ignoreEmptyCart && this.numberOfProducts === 0 ? 'display: none' : '';
    }

    private emitContinueShopping(continueShoppingUrl) {
      emit({
        element: this,
        name: 'continue-shopping',
        detail: {
          label: "Continue Shopping",
          href: continueShoppingUrl,
        }
      });
    }
 }

declare global {
    interface HTMLElementTagNameMap {
      'mhecomm-continue-shopping': ContinueShopping;
    }
}
